import { createAction, props } from '@ngrx/store';

import { SearchOrigins } from '@shared/search/domain/state/search.state';

export const SearchActionTypes = {
    INIT_SEARCH: '[search] INIT_SEARCH',
    LOAD_SEARCH_SUCCESS: '[search] LOAD_SEARCH_SUCCESS',
    LOAD_SEARCH_ERROR: '[search] LOAD_SEARCH_ERROR',

    SET_SEARCH_SECTION: '[search] SET_SEARCH_SECTION',
    SET_SEARCH_SECTION_SUCCESS: '[search] SET_SEARCH_SECTION_SUCCESS',
    SET_SEARCH_SECTION_ERROR: '[search] SET_SEARCH_SECTION_ERROR',

    MAKE_SEARCH: '[search] MAKE_SEARCH',
    MAKE_SEARCH_SUCCESS: '[search] MAKE_SEARCH_SUCCESS',
    MAKE_SEARCH_ERROR: '[search] MAKE_SEARCH_ERROR',

    OPEN_SEARCH: '[search] OPEN_SEARCH',
    CLOSE_SEARCH: '[search] CLOSE_SEARCH',
};

export const InitSearch = createAction(SearchActionTypes.INIT_SEARCH);
export const LoadSearchSuccess = createAction(SearchActionTypes.LOAD_SEARCH_SUCCESS);
export const LoadSearchError = createAction(SearchActionTypes.LOAD_SEARCH_ERROR, props<{ error }>());

export const SetSearchSection = createAction(SearchActionTypes.SET_SEARCH_SECTION);
export const SetSearchSectionSuccess = createAction(SearchActionTypes.SET_SEARCH_SECTION_SUCCESS);
export const SetSearchSectionError = createAction(SearchActionTypes.SET_SEARCH_SECTION_ERROR, props<{ error: any }>());

export const OpenSearch = createAction(SearchActionTypes.OPEN_SEARCH);
export const CloseSearch = createAction(SearchActionTypes.CLOSE_SEARCH);

export const MakeSearch = createAction(
    SearchActionTypes.MAKE_SEARCH,
    props<{
        searchTerm: string;
        origin: SearchOrigins;
        totalHits?: string;
        triggerWindowInterfaceX?: boolean;
    }>()
);
export const MakeSearchSuccess = createAction(SearchActionTypes.MAKE_SEARCH_SUCCESS);
export const MakeSearchError = createAction(SearchActionTypes.MAKE_SEARCH_ERROR, props<{ error: any }>());
